module.exports = __webpack_public_path__ + "static/icons/icon-print-b31a23049c3947a9861cff31cde753f2.svg";